// extracted by mini-css-extract-plugin
module.exports = {"change-answer":"dd31006766--change-answer--jmI9O"};